import React from 'react';
import { Modal, Card, Row, Col, Typography, Avatar, Grid } from 'antd';

const { Title, Paragraph, Text } = Typography;

interface TeamModalProps {
    visible: boolean;
    onCancel: () => void;
}

const TeamModal: React.FC<TeamModalProps> = ({ visible, onCancel }) => {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isNarrowScreen = !screens.md;

    const teamMembers = [
        {
            id: 1,
            name: "Ke Ni",
            title: "Co-first Author & Corresponding Author",
            avatar: "KN"
        },
        {
            id: 2,
            name: "Yuhao Chen",
            title: "Co-first Author",
            avatar: "YC"
        },
        {
            id: 3,
            name: "Danqing Angela Yin",
            title: "Co-first Author",
            avatar: "DY"
        },
        {
            id: 4,
            name: "Ze Yu",
            title: "Engineer",
            avatar: "ZY"
        },
        {
            id: 5,
            name: "Huidong Su",
            title: "Researcher",
            avatar: "HS"
        },
        {
            id: 6,
            name: "Yanshuo Chen",
            title: "Researcher",
            avatar: "YS"
        },
        {
            id: 7,
            name: "Jixing Yuan",
            title: "Engineer",
            avatar: "JY"
        },
        {
            id: 8,
            name: "Yexiu Gao",
            title: "Engineer",
            avatar: "YG"
        },
        {
            id: 9,
            name: "Youqi Wang",
            title: "Engineer",
            avatar: "YW"
        },
        {
            id: 10,
            name: "Irene Gao",
            title: "Engineer",
            avatar: "IG"
        },
        {
            id: 11,
            name: "Xinyu Wang",
            title: "Engineer",
            avatar: "XW"
        },
        {
            id: 12,
            name: "Haojin Wu",
            title: "Researcher",
            avatar: "HW"
        },
        {
            id: 13,
            name: "Jie Pan",
            title: "Engineer",
            avatar: "JP"
        },
        {
            id: 14,
            name: "Zeping Gui",
            title: "Scientific/Clinical Consultant",
            avatar: "ZG"
        },
        {
            id: 15,
            name: "Joshua W. K. Ho",
            title: "Scientific/Clinical Consultant",
            avatar: "JH"
        }, 
        {
            id: 16,
            name: "Ming Chen",
            title: "Product Manager",
            avatar: "MC"
        }
    ];

    const getTitleColor = (title: string) => {
        if (title.includes('Corresponding')) return '#1a365d';
        if (title.includes('Co-first')) return '#2d3748';
        if (title.includes('Consultant')) return '#4a5568';
        return '#718096';
    };

    return (
        <Modal
            title={null}
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={isNarrowScreen ? "95%" : "95%"}
            style={{
                maxWidth: isNarrowScreen ? "95vw" : 1400,
                top: isNarrowScreen ? 20 : 20,
                maxHeight: '95vh',
            }}
            styles={{
                body: {
                    padding: 0,
                    height: 'auto',
                    maxHeight: '85vh',
                    display: 'flex',
                    flexDirection: 'column'
                },
                content: {
                    borderRadius: 8,
                    overflow: 'hidden',
                    height: 'auto',
                    maxHeight: '95vh',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <div style={{
                background: '#fff',
                padding: isNarrowScreen ? '24px 16px' : '32px 32px 24px 32px',
                borderBottom: '2px solid #e2e8f0',
                flexShrink: 0
            }}>
                <div style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto' }}>
                    <Title level={1} style={{
                        margin: 0,
                        fontSize: isNarrowScreen ? 24 : 32,
                        fontWeight: 600,
                        color: '#1a365d',
                        marginBottom: 8,
                        letterSpacing: '-0.5px'
                    }}>
                        Ragomics Research Team
                    </Title>
                    <Paragraph style={{
                        fontSize: isNarrowScreen ? 14 : 16,
                        color: '#4a5568',
                        margin: '16px 0 0 0',
                        lineHeight: 1.6,
                        fontWeight: 400,
                        padding: isNarrowScreen ? '0 8px' : 0
                    }}>
                        Our interdisciplinary team combines expertise in computational biology, machine learning,
                        and software engineering to advance single-cell genomics research and develop accessible analytical tools.
                    </Paragraph>
                </div>
            </div>

            <div style={{
                padding: isNarrowScreen ? '24px 16px' : '32px',
                background: '#f7fafc',
                flex: '1 1 auto',
                overflowY: 'auto',
                minHeight: 0
            }}>
                <Row gutter={[isNarrowScreen ? 12 : 20, isNarrowScreen ? 12 : 20]}>
                    {teamMembers.map((member) => (
                        <Col xs={12} sm={8} md={6} lg={6} key={member.id}>
                            <Card
                                style={{
                                    height: '100%',
                                    borderRadius: 6,
                                    border: '1px solid #e2e8f0',
                                    transition: 'all 0.2s ease',
                                    background: '#fff'
                                }}
                                styles={{
                                    body: {
                                        padding: isNarrowScreen ? '12px' : '16px',
                                        textAlign: 'center'
                                    }
                                }}
                                hoverable
                            >
                                <Avatar
                                    size={isNarrowScreen ? 36 : 48}
                                    style={{
                                        background: '#718096',
                                        fontSize: isNarrowScreen ? 12 : 14,
                                        fontWeight: 500,
                                        marginBottom: isNarrowScreen ? 8 : 12
                                    }}
                                >
                                    {member.avatar}
                                </Avatar>
                                <Title level={5} style={{
                                    margin: 0,
                                    fontSize: isNarrowScreen ? 12 : 14,
                                    color: '#1a365d',
                                    fontWeight: 600,
                                    lineHeight: 1.3,
                                    marginBottom: 4
                                }}>
                                    {member.name}
                                </Title>
                                <Text style={{
                                    color: getTitleColor(member.title),
                                    fontWeight: 500,
                                    fontSize: isNarrowScreen ? 10 : 11,
                                    display: 'block',
                                    lineHeight: 1.2
                                }}>
                                    {member.title}
                                </Text>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </Modal>
    );
};

export default TeamModal;